module.exports = __webpack_public_path__ + "static/media/instagram-icon.40e207e6.svg";